import { OffersPromoRepository } from "../Repository/OffersPromoRepository";
import { OfferItemsOrder, Offers } from "../Model/Offers";

export interface UpdateTableOfferUseCase {
    invoke: (data: OfferItemsOrder[]) => Promise<boolean>;
  }
  
  export class UpdateTableOffer implements UpdateTableOfferUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(data: OfferItemsOrder[]){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateTableOffer(data);
        return update;
    }
  }